"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Jumbotron = _interopRequireDefault(require("react-bootstrap/Jumbotron"));
var _customHooks = require("../custom-hooks");
var _link = require("../link");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Jumbotron = allProps => {
  const {
    children,
    variant,
    posterUrl,
    backgroundImageUrl,
    backgroundVideoUrlMd,
    backgroundVideoUrlLg,
    backgroundVideoUrlXl,
    ...props
  } = allProps;

  // Initializes the state for hooks.
  const [videoSource, setVideoSource] = (0, _react.useState)(null);
  const videoRef = (0, _react.useRef)(null);
  const windowSize = (0, _customHooks.useWindowSize)();

  // Conditionally displays the background image, when background image is defined.
  const imageDiv = backgroundImageUrl ? /*#__PURE__*/_react.default.createElement("div", {
    className: "background-image",
    style: {
      backgroundImage: `url('${(0, _link.absolute)({
        url: backgroundImageUrl
      })}')`
    }
  }) : null;

  // Checks if the video source properties exist, if so, inserts the '<video>' element.
  let video = false;
  if (backgroundVideoUrlMd || backgroundVideoUrlLg || backgroundVideoUrlXl) {
    video = true;
  }

  // Maps the appropriate video width property with the corresponding screen size breakpoints.
  const selectVideo = size => {
    if (size >= 768 && size < 992) {
      return backgroundVideoUrlMd;
    }
    if (size >= 992 && size < 1170) {
      return backgroundVideoUrlLg;
    }
    if (size >= 1170) {
      return backgroundVideoUrlXl;
    }
    return;
  };

  // Sets the video source according to the size defined.
  (0, _react.useEffect)(() => {
    setVideoSource(selectVideo(windowSize.width));
  }, [windowSize]);

  // Plays or swaps the video on initial load and when the breakpoint changes.
  (0, _react.useLayoutEffect)(() => {
    if (videoRef.current) {
      videoRef.current.load();
    }
  }, [videoRef]);

  // Note about React and the video element: React does not render the 'muted' attrib for some reason, though it DOES obey it when defined in the source (like below). See 'https://github.com/facebook/react/issues/10389'.

  const videoDiv = video ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("video", {
    key: videoSource,
    ref: videoRef,
    poster: posterUrl,
    className: "jumbotron-video",
    id: "jumbotronVideo",
    muted: true,
    preload: 'none',
    autoPlay: true,
    loop: true,
    playsInline: true
  }, /*#__PURE__*/_react.default.createElement("source", {
    src: videoSource
  }))) : null;

  // Maps the variant prop to the class name and swaps the class when the property changes.
  let variantClassName;
  switch (variant) {
    case 'dark-primary':
      variantClassName = 'jumbotron dark-scheme--primary';
      break;
    case 'dark-secondary':
      variantClassName = 'jumbotron dark-scheme--secondary';
      break;
    default:
      variantClassName = 'jumbotron';
      break;
  }
  return /*#__PURE__*/_react.default.createElement(_Jumbotron.default, _extends({}, props, {
    bsPrefix: variantClassName
  }), imageDiv, videoDiv, /*#__PURE__*/_react.default.createElement("div", {
    className: "container jumbotron-body"
  }, children));
};
Jumbotron.propTypes = {
  as: _propTypes.default.elementType,
  /**
   * This sets the style variant for the Jumbotron.
   */
  variant: _propTypes.default.oneOf(['basic', 'dark-primary', 'dark-secondary']),
  /**
   * This accepts a URL for the background image.
   */
  backgroundImageUrl: _propTypes.default.string,
  /**
   * This defines if the Jumbotron will use an (audioless) video background.
   */
  posterUrl: _propTypes.default.string,
  /**
   * This accepts a URL for the video "poster" background image. It should be the same background image as the `backgroundImageUrl` property
   */
  backgroundVideoUrlMd: _propTypes.default.string,
  /**
   * This accepts a URL for video that will be played at the Medium window size (768px) and up. Only a still image displays below that width.
   */
  backgroundVideoUrlLg: _propTypes.default.string,
  /**
   * This accepts a URL for video that will be played at the Medium window size (992px) and up.
   */
  backgroundVideoUrlXl: _propTypes.default.string
  /**
   * This accepts a URL for video that will be played at the Medium window size (1170px) and up.
   */
};

Jumbotron.defaultProps = {
  as: 'div',
  variant: 'basic'
};
var _default = exports.default = Jumbotron;